import { useTranslation } from 'react-i18next';
import type { LoadingProps } from '@standardsdigital/ui-components/Loading';
import Loading from '@standardsdigital/ui-components/Loading';
import styles from './Spinner.module.css';

interface SpinnerProps {
  position?: 'centerFixed' | 'centerAbsolute';
  size?: LoadingProps['size'];
  'aria-label'?: string;
}

function Spinner({
  position,
  size,
  'aria-label': ariaLabel,
}: Readonly<SpinnerProps>) {
  const { t } = useTranslation();
  let spinnerStyles = styles.spinnerWrapper;
  if (position) {
    spinnerStyles += ` ${styles[position]}`;
  }

  return (
    <div className={spinnerStyles}>
      <Loading size={size} aria-label={ariaLabel || t('general.loading')} />
    </div>
  );
}

export default Spinner;
